import { defineMessages, type MessageDescriptor } from 'react-intl';

export const messages: Record<string, MessageDescriptor> = defineMessages({
	errorFlagTitle: {
		id: 'ai-mate.creation-settings.auto-apply-toggle.error-flag-title',
		defaultMessage: 'Failed to update auto-apply setting',
		description: 'Title for the error flag when auto-apply toggle fails',
	},
	errorFlagDescription: {
		id: 'ai-mate.creation-settings.auto-apply-toggle.error-flag-description',
		defaultMessage: 'There was a problem saving your auto-apply preference. Please try again.',
		description: 'Description for the error flag when auto-apply toggle fails',
	},
});
